var Linker = require("../linker");

module.exports = function(library, destinations, deployer) {
  return function() {
    Linker.link(library, destinations, deployer.logger);
  };
};



//////////////////
// WEBPACK FOOTER
// ./packages/truffle-deployer/src/actions/link.js
// module id = 1193
// module chunks = 0